module.exports = __webpack_public_path__ + "img/02-departamentos.20a9e2c6.png";